import { render, staticRenderFns } from "./StudioMeetingBooking.vue?vue&type=template&id=4b7795bc&scoped=true&"
import script from "./StudioMeetingBooking.vue?vue&type=script&lang=js&"
export * from "./StudioMeetingBooking.vue?vue&type=script&lang=js&"
import style0 from "./StudioMeetingBooking.vue?vue&type=style&index=0&id=4b7795bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7795bc",
  null
  
)

export default component.exports